"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const layouts_1 = require("../../shared/layouts");
require("./app.scss");
require("./styles/profileInfoContainer.scss");
const lawFirmSlice_1 = require("../../redux/slices/lawFirmSlice");
const avatarApload_1 = __importDefault(require("../../shared/components/avatarApload/avatarApload"));
const profile_1 = require("../../shared/components/profile");
const actionBox_1 = __importDefault(require("./components/actionBox"));
const lawFirmProfileSlice_1 = require("../../redux/slices/lawFirmProfileSlice");
const staff_1 = __importDefault(require("./components/staff/staff"));
const contactInfo_1 = __importDefault(require("./components/contactInfo/contactInfo"));
const PlusIcon_1 = __importDefault(require("../../svgIcons/PlusIcon"));
const EditIcon_1 = __importDefault(require("../../svgIcons/EditIcon"));
class App extends react_1.default.Component {
    constructor() {
        super(...arguments);
        // handle inputs  change event
        this.formChange = (e, field, val = null) => {
            const value = e ? e.target.value : val;
            this.props.userFormChange({ value: value, field: field });
        };
        // handle inputs blur event
        this.validateInput = (e, field) => {
            const value = e.target.value;
            this.props.validateInputs({ value, field });
        };
        // save profile
        this.saveProfile = () => this.props.updateProfile(this.props.lawFirmProfile.formData, this.props.lawFirmProfile.practiceArea);
    }
    componentDidMount() {
        const { options: { userId } } = this.props;
        if (userId) {
            this.props.getUser(userId);
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { lawFirmProfile: { formUpdated } } = this.props;
        if (formUpdated) {
            localStorage.setItem('profile_changed', 'profile_changed');
        }
        else {
            localStorage.removeItem('profile_changed');
        }
    }
    render() {
        const { lawFirm, lawFirmProfile, options: { type } } = this.props;
        const { formData, validationFields, apiErrors, formValid, addressValid, avatarLoading, practiceAreaModal, practiceArea, errorMessage, editState } = lawFirmProfile;
        const user = lawFirm.user;
        const guest = type === 'guest';
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: `tab-titles ${guest || editState ? 'mb-30' : ''}` },
                "Profile",
                guest && user.deleted && react_1.default.createElement("span", { className: 'pt-10' }, "This account has been deleted.")),
            react_1.default.createElement(core_1.Box, { className: 'v2-main-container' },
                !guest && !editState && react_1.default.createElement("div", { className: 'text-right mb-10' },
                    react_1.default.createElement(core_1.Button, { onClick: this.props.toggleEdit, "data-qa": 'edit-profile', variant: "text", disableRipple: true, startIcon: react_1.default.createElement(EditIcon_1.default, null), className: "v2-btn-icon-link v2-edit-profile-btn" }, "Edit Profile")),
                react_1.default.createElement(core_1.Box, { id: `law-firm-profile`, className: `${guest && user.deleted ? 'deleted-view' : ''}` },
                    react_1.default.createElement(layouts_1.InfoContainer, { className: 'profile-info-container' },
                        react_1.default.createElement(avatarApload_1.default, { user: user, guest: guest, uploadAvatar: this.props.uploadAvatar, removeAvatar: this.props.removeAvatar, avatarLoading: avatarLoading }),
                        !editState && react_1.default.createElement("h4", { className: 'firm-name' }, user.firm_name),
                        guest && react_1.default.createElement("a", { type: "button", className: "v2-btn v2-btn-primary call-button mt-30", href: `tel:${user.contact_person}` }, "Call"),
                        !guest && editState && react_1.default.createElement("div", { className: "input-wrapper" },
                            react_1.default.createElement(core_1.Input, { fullWidth: true, value: formData.firm_name, error: validationFields.firmNameValid === false, onChange: (e) => this.formChange(e, 'firm_name'), onBlur: (e) => this.validateInput(e, 'firm_name'), placeholder: 'Law Firm Name', id: "full-name" }))),
                    react_1.default.createElement(core_1.Box, { className: 'profile-details-container' },
                        react_1.default.createElement(layouts_1.InfoContainer, { className: 'w-100 flex-column' },
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'About' },
                                react_1.default.createElement(profile_1.About, { user: user, guest: guest, inputChange: (e) => this.formChange(e, 'bio'), edit: editState, value: formData.bio, error: false })),
                            react_1.default.createElement("div", { className: "block-separator" }),
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'Practice Areas', headerContent: !guest && react_1.default.createElement(core_1.Button, { onClick: () => this.props.togglePracticeAreasModal(), "data-qa": 'add-practice-area', className: "v2-btn-icon-link", startIcon: react_1.default.createElement(PlusIcon_1.default, null), variant: "text", disableRipple: true }, " Add ") },
                                react_1.default.createElement(profile_1.PracticeArea, { edit: editState, guest: guest, changeArea: this.props.changeArea, practiceArea: practiceArea, setFormUpdate: this.props.setFormUpdate }),
                                practiceAreaModal && react_1.default.createElement(profile_1.PracticeAreaModal, { user: user, profile: lawFirmProfile, changeArea: this.props.changeArea, togglePracticeAreasModal: this.props.togglePracticeAreasModal, savePracticeAreas: this.props.savePracticeAreas })),
                            react_1.default.createElement("div", { className: "block-separator" }),
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'Number of Employees' },
                                react_1.default.createElement(staff_1.default, { attorneysRange: user.att_range_value, guest: guest, edit: editState, inputValue: formData.attorneys_range, inputChange: this.formChange })),
                            react_1.default.createElement("div", { className: "block-separator" }),
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'Contact Information' },
                                react_1.default.createElement(contactInfo_1.default, { user: user, edit: editState, formChange: this.formChange, validationFields: validationFields, apiErrors: apiErrors, addressValid: addressValid, validateInput: this.validateInput, setApiError: this.props.setApiError, validateAddress: this.props.validateAddress, formData: formData }))),
                        editState && react_1.default.createElement(actionBox_1.default, { mainBtn: react_1.default.createElement(core_1.Button, { onClick: () => this.saveProfile(), "data-qa": 'save-btn', onDoubleClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }, className: 'v2-btn v2-btn-primary' }, "Save"), secondaryBtn: react_1.default.createElement(core_1.Button, { onClick: () => {
                                    this.props.toggleEdit();
                                    this.props.resetState();
                                }, "data-qa": 'never-mind-btn', onDoubleClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }, className: "v2-btn v2-btn-tertiary" }, "Never Mind") }),
                        formValid === false || !addressValid ?
                            react_1.default.createElement(core_1.FormHelperText, { error: true, className: 'helper-text-error' }, errorMessage) : null)))));
    }
}
const mapStateToProps = (state) => {
    const { lawFirm, lawFirmProfile } = state;
    return {
        lawFirm,
        lawFirmProfile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (id) => dispatch(lawFirmSlice_1.getLawFirmUser(id)),
        setProfileForm: () => dispatch(lawFirmProfileSlice_1.setProfileForm()),
        userFormChange: ({ value, field }) => dispatch(lawFirmProfileSlice_1.userFormChange({ value, field })),
        updateProfile: (data, practiceArea) => dispatch(lawFirmProfileSlice_1.updateProfile(data, practiceArea)),
        validateInputs: ({ value, field }) => dispatch(lawFirmProfileSlice_1.validateInputs({ value, field })),
        setApiError: ({ field, status }) => dispatch(lawFirmProfileSlice_1.setApiError({ field, status })),
        validateAddress: () => dispatch(lawFirmProfileSlice_1.validateAddress()),
        resetState: () => dispatch(lawFirmProfileSlice_1.resetState()),
        toggleEdit: () => dispatch(lawFirmProfileSlice_1.toggleProfileEdit()),
        uploadAvatar: (data) => dispatch(lawFirmProfileSlice_1.uploadAvatar(data)),
        removeAvatar: (data) => dispatch(lawFirmProfileSlice_1.removeAvatar(data)),
        changeArea: (data, type, deleted) => dispatch(lawFirmProfileSlice_1.changeArea(data, type, deleted)),
        savePracticeAreas: (data, id) => dispatch(lawFirmProfileSlice_1.savePracticeAreas(data, id)),
        togglePracticeAreasModal: () => dispatch(lawFirmProfileSlice_1.togglePracticeAreasModal()),
        setFormUpdate: () => dispatch(lawFirmProfileSlice_1.setFormUpdate())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
